export const COLORS = {
  PRIMARY_LIGHT_3: '#FFF4DE',
  PRIMARY_LIGHT_2: '#FFDB91',
  PRIMARY_LIGHT_1: '#FFCF6A',
  PRIMARY_BASE: '#FFB719',
  PRIMARY_DARK_1: '#E5A110',
  PRIMARY_DARK_2: '#C08507',
  PRIMARY_DARK_3: '#AD7701',

  SECONDARY_LIGHT_3: '#EAF0FA',
  SECONDARY_LIGHT_2: '#AFC5EF',
  SECONDARY_LIGHT_1: '#749BE4',
  SECONDARY_BASE: '#376FD8',
  SECONDARY_DARK_1: '#264E99',
  SECONDARY_DARK_2: '#132850',
  SECONDARY_DARK_3: '#09152B',

  USER_BG: '#FFF4DE',
  BACKYARD_BG: '#132850',

  GRAY_LIGHT_BG_4: '#FAFAFA',
  GRAY_LIGHT_BG_3: '#F2F2F2',
  GRAY_LIGHT_BG_2: '#D7D7D6',
  GRAY_LIGHT_BG_1: '#B5B5B4',
  GRAY_BASE_BG: '#908F8E',
  GRAY_DARK_BG_1: '#686765',
  GRAY_DARK_BG_2: '#454441',
  GRAY_DARK_BG_3: '#2A2927',

  BLUE_LIGHT_BG: '#E5F6FF',
  BLUE_DARK_BG: '#BAE3F8',

  RED_LIGHT_BG: '#FFE6E5',
  RED_DARK_BG: '#FFB4B1',

  GRAY_LIGHT_TEXT_4: '#FAFAFA',
  GRAY_LIGHT_TEXT_3: '#F2F2F2',
  GRAY_LIGHT_TEXT_2: '#D7D7D6',
  GRAY_LIGHT_TEXT_1: '#B5B5B4',
  GRAY_BASE_TEXT: '#908F8E',
  GRAY_DARK_TEXT_1: '#686765',
  GRAY_DARK_TEXT_2: '#454441',
  GRAY_DARK_TEXT_3: '#2A2927',

  GRAY_LIGHT_BORDER_4: '#FAFAFA',
  GRAY_LIGHT_BORDER_3: '#F2F2F2',
  GRAY_LIGHT_BORDER_2: '#D7D7D6',
  GRAY_LIGHT_BORDER_1: '#B5B5B4',
  GRAY_BASE_BORDER: '#908F8E',
  GRAY_DARK_BORDER_1: '#686765',
  GRAY_DARK_BORDER_2: '#454441',
  GRAY_DARK_BORDER_3: '#2A2927',

  BLUE_LIGHT_BORDER: '#E5F6FF',
  BLUE_DARK_BORDER_1: '#BAE3F8',
  BLUE_DARK_BORDER_2: '#4095DD',

  RED_LIGHT_BORDER: '#FFE6E5',
  RED_DARK_BORDER_1: '#FFB4B1',
  RED_DARK_BORDER_2: '#DF6963',

  EGD_LOW: '#D7D7D6',
  EGD_LOW_BAR: 'rgba(215, 215, 214, 0.9)',
  EGD_MIDDLE: '#FFDB91',
  EGD_MIDDLE_BAR: 'rgba(255, 219, 145, 0.9)',
  EGD_HIGH: '#BAE3F8',
  EGD_HIGH_BAR: 'rgba(186, 227, 248, 0.9)',

  SUCCESS: '#43A047',
  DANGER: '#D1281F',
  DANGER_DARK: '#BF3313',
  WARNING: '#EFCA05',
  INFO: '#13A9CA',

  WHITE: '#fff',
  RED: '#F54500',
};

export const FONT_SIZES = {
  FS_10: '10px',
  FS_11: '11px',
  FS_12: '12px',
  FS_13: '13px',
  FS_BASE: '14px',
  FS_15: '15px',
  FS_16: '16px',
  FS_18: '18px',
  FS_20: '20px',
  FS_22: '22px',
  FS_24: '24px',
  FS_25: '25px',
  FS_26: '26px',
  FS_30: '30px',
  FS_40: '40px',
  FS_48: '48px',
  FS_50: '50px',
  FS_60: '60px',
};
